<ng-container *ngIf="menuStyle === menuStyles.TOP_MENU">
  <app-top-menu></app-top-menu>
  <main>
    <router-outlet></router-outlet>
  </main>
</ng-container>
<ng-container *ngIf="menuStyle === menuStyles.SIDE_MENU">
  <app-side-menu>
    <router-outlet></router-outlet>
  </app-side-menu>
</ng-container>
<app-footer *ngIf="footerStyle === footerStyles.DETAILED"></app-footer>
<app-simple-footer
  *ngIf="footerStyle === footerStyles.SIMPLE"
></app-simple-footer>
